(function () {
  var LOG = '[gclid-global]';
  var STORAGE_KEY = 'rau_marketing_gclid';
  var LEGACY_KEY = 'gclid';

  function decodeParam(v) {
    if (!v) return '';
    try {
      return decodeURIComponent(String(v).replace(/\+/g, ' ')).trim();
    } catch (e) {
      return String(v).trim();
    }
  }

  function getGclidFromUrl() {
    try {
      var g = new URLSearchParams(window.location.search || '').get('gclid');
      if (g) return decodeParam(g);

      var hash = window.location.hash || '';
      var q = hash.indexOf('?');
      if (q !== -1) {
        g = new URLSearchParams(hash.slice(q)).get('gclid');
        if (g) return decodeParam(g);
      }

      var match = hash.match(/[#&]gclid=([^&]+)/);
      if (match) return decodeParam(match[1]);
    } catch (e) {
      return '';
    }
    return '';
  }

  function persistGclidFromUrl() {
    try {
      var gclid = getGclidFromUrl();
      if (gclid) {
        window.localStorage.setItem(STORAGE_KEY, gclid);
        window.localStorage.setItem(LEGACY_KEY, gclid);
        console.log(LOG, 'saved gclid from URL to localStorage', {
          preview: gclid.slice(0, 24) + (gclid.length > 24 ? '…' : ''),
        });
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
        window.localStorage.removeItem(LEGACY_KEY);
      }
    } catch (e) {
      console.warn(LOG, 'capture failed', e);
    }
  }

  persistGclidFromUrl();
  window.addEventListener('hashchange', persistGclidFromUrl);
  window.addEventListener('popstate', persistGclidFromUrl);
})();
